/* assets/mm-bundle-banner.js — <mm-bundle-banner>: Farbe folgt Sortenschalter, Rabattcode vorbelegen, Tracking */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('mm-bundle-banner')) return;
  var PATTERN = ['dark', 'fruit', 'light', 'fruit', 'dark', 'fruit', 'dark']; // Stop-Reihenfolge der Variante „fruit“ im Swirl-Snippet
  class MMBundleBanner extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this); this.addEventListener('click', this._onClick);
      if (this.hasAttribute('data-follow-flavor')) {
        this._onFlavor = this._onFlavor.bind(this); document.addEventListener('mm:flavor-change', this._onFlavor);
        var cs = getComputedStyle(document.documentElement), fruit = cs.getPropertyValue('--mm-fruit').trim();
        if (fruit) this._apply({ fruit: fruit, light: cs.getPropertyValue('--mm-fruit-light').trim(), dark: cs.getPropertyValue('--mm-fruit-dark').trim() });
      }
    }
    disconnectedCallback() { this.removeEventListener('click', this._onClick); if (this._onFlavor) document.removeEventListener('mm:flavor-change', this._onFlavor); }
    _onFlavor(evt) { var d = evt.detail || {}; if (d.colors) this._apply(d.colors); }
    _apply(c) {
      if (!c.fruit) return;
      this.style.backgroundColor = c.fruit;
      var stops = this.querySelectorAll('[data-mm-duo-swirl] linearGradient stop');
      stops.forEach(function (s, i) { var k = PATTERN[i % PATTERN.length]; var col = c[k] || c.fruit; s.setAttribute('stop-color', col); });
    }
    _onClick(evt) {
      var btn = evt.target.closest('[data-mm-atc]'); if (!btn || !this.contains(btn) || btn.disabled) return;
      var code = this.dataset.discountCode;
      if (code && !this._discountApplied) {
        this._discountApplied = true;
        try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' }).catch(function () {}); } catch (e) {}
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'mm_add_to_cart', product_id: btn.dataset.productId, variant_id: btn.dataset.variantId, section: 'bundle-banner', discount_code: code || undefined });
      }
    }
  }
  customElements.define('mm-bundle-banner', MMBundleBanner);
})();
